import {
  apiRoutes,
  getIntercityOrderDetailFn,
  type DefaultQueryError,
  type IntercityOrder,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetIntercityOrderDetail = (
  orderId: string,
  opts?: Omit<UseQueryOptions<IntercityOrder, DefaultQueryError>, 'queryKey'>
) =>
  useQuery<IntercityOrder, DefaultQueryError>({
    queryKey: [apiRoutes.intercity.details(orderId)],
    queryFn: () => getIntercityOrderDetailFn(orderId),
    ...opts,
  });
